export default function range(start, end) {
  var ans = [];
  for (let i = start; i < end; i++) {
      ans.push(i);
  }
  return ans;
}